module.exports = __webpack_public_path__ + "static/media/CSS.0504cab9.png";